import { booleanField, stringField } from 'common/utils/form/fieldTypes';

const config = {
  name: stringField({ required: true }),
  username: stringField({ required: true }),
  password: stringField({ required: true }),
  confirm_password: stringField({ required: true }),
  is_admin: booleanField({ initialValue: false })
};

export default config;
